module.exports = __webpack_public_path__ + "img/d4.c5a50e85.png";